
import QuestionMarkIcon from '@mui/icons-material/QuestionMark';

import "./customicons.css"

export const QuestionIcon = ({ disabled, onClick }) => {

  return (
   
    <div>
      <QuestionMarkIcon className= "iconQuestion"  sx={{ fontSize: 25 }} onClick = {onClick}/>
    </div> 

  )
}
  




